/*
 * Tab content registry.
 *
 * Maps moduleName → tabKey → Component rendered below the header.
 * The 'details' tab always uses the default DetailViewV1 layout — never register it here.
 *
 * To add content for a new module/tab:
 *   1. Import the component.
 *   2. Add an entry: REGISTRY[moduleName][tabKey] = ({ id, ...rest }) => <YourTab ... />.
 *
 * Props passed to every registered component: { id, moduleName, onDescriptionSaved }
 */
import CandidatesTab from '../../pages/Modules/Jobs/Candidates/CandidatesTab';

const REGISTRY = {
  job: {
    candidates: ({ id, onDescriptionSaved }) => (
      <CandidatesTab jobId={id} onDescriptionSaved={onDescriptionSaved} />
    ),
  },
  // Add future modules here:
  // candidate: { jobs: ({ id }) => <CandidateJobsTab candidateId={id} /> },
};

export function getTabContent(moduleName, tabKey) {
  if (!tabKey || tabKey === 'details') return null;
  return REGISTRY[moduleName]?.[tabKey] ?? null;
}
